/* eslint class-methods-use-this: 0, no-unused-vars: 0 */

/**
 * Missing policy that returns source string
 *
 * @export
 * @class SourceStringPolicy
 */
export default class SourceStringPolicy {
  handle(sourceString, localeCode, params) {
    return sourceString;
  }
}
